import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-e98719a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 px-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "row w-full flex justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "courseDescription" }
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_14 = { class: "formcontainer flex flex-col" }
const _hoisted_15 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Course Type", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Select Course Type", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "text-red-500 error-text"
}
const _hoisted_22 = { class: "w-6/12 leftspacing" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Max Duration (In Days)", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "text-red-500 error-text"
}
const _hoisted_27 = {
  key: 1,
  class: "text-red-500 error-text"
}
const _hoisted_28 = {
  key: 2,
  class: "text-red-500 error-text"
}
const _hoisted_29 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_30 = { class: "w-6/12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Course Expiry (In Days)", -1))
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "text-red-500 error-text"
}
const _hoisted_35 = {
  key: 1,
  class: "text-red-500 error-text"
}
const _hoisted_36 = {
  key: 2,
  class: "text-red-500 error-text"
}
const _hoisted_37 = {
  key: 3,
  class: "text-red-500 error-text"
}
const _hoisted_38 = { class: "w-6/12 leftspacing" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Access", -1))
const _hoisted_40 = ["disabled"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Access type", -1))
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_44 = {
  key: 0,
  class: "error-text"
}
const _hoisted_45 = { class: "row flex flex-row w-full" }
const _hoisted_46 = {
  key: 0,
  class: "w-6/12 upperspacing"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Locations", -1))
const _hoisted_48 = ["disabled"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Locations", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_52 = {
  key: 0,
  class: "error-text"
}
const _hoisted_53 = {
  key: 1,
  class: "upperspacing leftspacing w-6/12"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Target Audience", -1))
const _hoisted_55 = ["disabled"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Target Audience", -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_59 = {
  key: 0,
  class: "error-text"
}
const _hoisted_60 = {
  key: 2,
  class: "upperspacing leftspacing w-6/12"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Region Access", -1))
const _hoisted_62 = ["disabled"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Region", -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = {
  key: 3,
  class: "upperspacing w-6/12"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Global Access", -1))
const _hoisted_67 = ["disabled"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Target Audience", -1))
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_71 = {
  key: 0,
  class: "error-text"
}
const _hoisted_72 = { class: "row flex flex-row w-full" }
const _hoisted_73 = {
  key: 0,
  class: "w-full upperspacing"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Teams", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No teams Found", -1))
const _hoisted_76 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_77 = {
  key: 0,
  class: "error-text"
}
const _hoisted_78 = {
  key: 1,
  class: "upperspacing w-6/12"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Entity", -1))
const _hoisted_80 = ["disabled"]
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Locations", -1))
const _hoisted_82 = ["value"]
const _hoisted_83 = {
  key: 2,
  class: "upperspacing leftspacing w-6/12"
}
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Target Audience", -1))
const _hoisted_85 = ["disabled"]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}, "Please select Target Audience", -1))
const _hoisted_87 = ["value"]
const _hoisted_88 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_89 = {
  key: 0,
  class: "error-text"
}
const _hoisted_90 = { class: "row flex flex-row w-full" }
const _hoisted_91 = {
  key: 0,
  class: "upperspacing w-full"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Teams", -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = {
  key: 1,
  class: "upperspacing w-full"
}
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Users", -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = {
  key: 2,
  class: "upperspacing w-full"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Teams", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No Teams Found", -1))
const _hoisted_100 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_101 = {
  key: 0,
  class: "error-text"
}
const _hoisted_102 = {
  key: 3,
  class: "upperspacing w-full"
}
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel text-black" }, "Users", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No Users Found", -1))
const _hoisted_105 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_106 = {
  key: 0,
  class: "error-text"
}
const _hoisted_107 = { class: "flex items-center mt-2 justify-start" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "forceUpdate",
  class: "text-sm ml-2 cursor-pointer w-auto text-left controllabel"
}, "Force Update", -1))
const _hoisted_109 = { class: "flex justify-center" }
const _hoisted_110 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_111 = {
  key: 1,
  class: "flex justify-center items-center"
}
const _hoisted_112 = {
  key: 2,
  class: "flex justify-center items-center ml-6"
}
const _hoisted_113 = {
  key: 3,
  class: "buttonposition flex justify-center items-center ml-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", {
        class: _normalizeClass(_ctx.datacourse[0] != undefined && _ctx.datacourse[0].courseName.length > 40? 'table-ellipsis w-1/2 h-6':'')
      }, _toDisplayString(_ctx.datacourse[0] != undefined ? _ctx.datacourse[0].courseName : ''), 3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "ml-3 btnprimary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCoursesData && _ctx.addCoursesData(...args)))
        }, " Add "),
        _createElementVNode("button", {
          class: _normalizeClass(["ml-3 flex", _ctx.courseData.length != 0  ? 'filterButton' : 'btndisabled pointer-events-none']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterOpen()))
        }, [
          (_ctx.courseData.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : (_openBlock(), _createElementBlock("img", _hoisted_6)),
          _createTextVNode(" Filters ")
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.courseDescriptionObject), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.courseData,
        headersData: _ctx.Headers,
        openPopup: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"])
    ]),
    (_ctx.singlecourse.isShow)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.singlecourse.isShow
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h1", {
                class: _normalizeClass(_ctx.datacourse[0] != undefined && _ctx.datacourse[0].courseName.length > 40? 'table-ellipsis w-1/2 h-6':'')
              }, _toDisplayString(_ctx.datacourse[0].courseName), 3),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCrossBtn()))
              }, _hoisted_12)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("form", null, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: "w-6/12",
                          disabled: _ctx.locationBasedOptionsDisable==false
                        }, [
                          _hoisted_17,
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling mt-2", {
													'is-invalid': _ctx.v$.locationBasedOptions.courseTypeCodeId.$error,
												}]),
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.locationBasedOptions.courseTypeCodeId) = $event))
                          }, [
                            _hoisted_18,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseTypeCodeId, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "taskStatusOptions",
                                key: option.value,
                                value: option.value
                              }, _toDisplayString(option.label), 9, _hoisted_19))
                            }), 128))
                          ], 2), [
                            [_vModelSelect, _ctx.locationBasedOptions.courseTypeCodeId]
                          ]),
                          (_ctx.v$.locationBasedOptions.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (_ctx.v$.locationBasedOptions.courseTypeCodeId.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_16),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.dueDays.$error || this.locationBasedOptions.dueDays==0 || this.locationBasedOptions.dueDays<0
												}]),
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.locationBasedOptions.dueDays) = $event)),
                            disabled: _ctx.locationBasedOptionsDisable==false,
                            placeholder: "Please enter course duration"
                          }, null, 10, _hoisted_24), [
                            [_vModelText, _ctx.locationBasedOptions.dueDays]
                          ]),
                          (_ctx.v$.locationBasedOptions.$error || this.locationBasedOptions.dueDays==0 || this.locationBasedOptions.dueDays < 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (_ctx.v$.locationBasedOptions.dueDays.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Required"))
                                  : (_ctx.v$.locationBasedOptions.dueDays.numeric.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Value should be numeric"))
                                    : (this.locationBasedOptions.dueDays==0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, "value should not be zero"))
                                      : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.courseExpiry.$error || _ctx.locationBasedOptions.courseExpiry==0 ||_ctx.locationBasedOptions.courseExpiry < _ctx.locationBasedOptions.dueDays
												}]),
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.locationBasedOptions.courseExpiry) = $event)),
                            disabled: _ctx.locationBasedOptionsDisable==false,
                            placeholder: "Please enter Course Expiry"
                          }, null, 10, _hoisted_32), [
                            [_vModelText, _ctx.locationBasedOptions.courseExpiry]
                          ]),
                          (_ctx.v$.locationBasedOptions.$error || _ctx.locationBasedOptions.courseExpiry==0 || _ctx.locationBasedOptions.courseExpiry < _ctx.locationBasedOptions.dueDays)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                (_ctx.v$.locationBasedOptions.courseExpiry.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Required"))
                                  : (_ctx.v$.locationBasedOptions.courseExpiry.numeric.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Value should be numeric"))
                                    : (_ctx.locationBasedOptions.courseExpiry==0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Value should not be zero"))
                                      : (_ctx.locationBasedOptions.courseExpiry < _ctx.locationBasedOptions.dueDays)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, "Value should be greater than Max Duration"))
                                        : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.type.$error
												}]),
                            onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.globalAccess && _ctx.globalAccess(...args))),
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.locationBasedOptions.type) = $event)),
                            disabled: _ctx.locationBasedOptionsDisable==false
                          }, [
                            _hoisted_41,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type, (option) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: option.id,
                                value: option.typeId,
                                class: _normalizeClass({ hidden: option.typeId === 20302 })
                              }, _toDisplayString(option.data), 11, _hoisted_42))
                            }), 128))
                          ], 42, _hoisted_40), [
                            [_vModelSelect, _ctx.locationBasedOptions.type]
                          ]),
                          (_ctx.v$.locationBasedOptions.type.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                (_ctx.v$.locationBasedOptions.type.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        (_ctx.locationBasedOptions.type == 20303)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                              _hoisted_47,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.entityId.$error
												}]),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.locationBasedOptions.entityId) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getEntityTeamsList(_ctx.locationBasedOptions.entityId)))
                              }, [
                                _hoisted_49,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entitesDataArray, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: option._id
                                  }, _toDisplayString(option.entityDisplayName), 9, _hoisted_50))
                                }), 128))
                              ], 42, _hoisted_48), [
                                [_vModelSelect, _ctx.locationBasedOptions.entityId]
                              ]),
                              (_ctx.v$.locationBasedOptions.entityId.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                    (_ctx.v$.locationBasedOptions.entityId.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20303 && _ctx.locationBasedOptions.entityId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _hoisted_54,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.courseTargetTypeCodeId.$error
												}]),
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.locationBasedOptions.courseTargetTypeCodeId) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleAccessLevelTwoChange && _ctx.handleAccessLevelTwoChange(...args)))
                              }, [
                                _hoisted_56,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLevelTwo, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: option.id,
                                    value: option.courseTargetTypeCodeId,
                                    class: _normalizeClass({ hidden: option.id == 10503 })
                                  }, _toDisplayString(option.data), 11, _hoisted_57))
                                }), 128))
                              ], 42, _hoisted_55), [
                                [_vModelSelect, _ctx.locationBasedOptions.courseTargetTypeCodeId]
                              ]),
                              (_ctx.v$.locationBasedOptions.courseTargetTypeCodeId.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    (_ctx.v$.locationBasedOptions.courseTargetTypeCodeId.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20302)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                              _hoisted_61,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.region.$error
												}]),
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.locationBasedOptions.region) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.regionAccesshandler(_ctx.locationBasedOptions.region)))
                              }, [
                                _hoisted_63,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionDataArray, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: index,
                                    value: option._id
                                  }, _toDisplayString(option.region), 9, _hoisted_64))
                                }), 128))
                              ], 42, _hoisted_62), [
                                [_vModelSelect, _ctx.locationBasedOptions.region]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20301)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["inputboxstyling mt-2 text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.courseTargetTypeCodeId.$error
												}]),
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.locationBasedOptions.courseTargetTypeCodeId) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleAccessLevelTwoChange && _ctx.handleAccessLevelTwoChange(...args)))
                              }, [
                                _hoisted_68,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLevelTwo, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: option.id,
                                    value: option.courseTargetTypeCodeId,
                                    class: _normalizeClass({ hidden: option.courseTargetTypeCodeId == 10503 })
                                  }, _toDisplayString(option.courseTargetTypeCodeId === 10501 && _ctx.locationBasedOptions.type === 'global' ? 'All Entities' : option.data), 11, _hoisted_69))
                                }), 128))
                              ], 42, _hoisted_67), [
                                [_vModelSelect, _ctx.locationBasedOptions.courseTargetTypeCodeId]
                              ]),
                              (_ctx.v$.locationBasedOptions.courseTargetTypeCodeId.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    (_ctx.v$.locationBasedOptions.courseTargetTypeCodeId.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        (_ctx.locationBasedOptions.type == 20301 && _ctx.locationBasedOptions.courseTargetTypeCodeId == 10502)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                              _hoisted_74,
                              _createVNode(_component_multiselect, {
                                modelValue: _ctx.locationBasedOptions.departments,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.locationBasedOptions.departments) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                class: _normalizeClass(["custom-multiselect text-black", {
													'is-invalidmultiselect':_ctx.v$.locationBasedOptions.departments.$error,
													'has-options': _ctx.globalTeams && _ctx.globalTeams.length > 0,
                                    				'no-options': !_ctx.globalTeams.length &&  _ctx.searchValue !== '',
												}]),
                                options: _ctx.globalTeams,
                                showNoOptions: false,
                                searchable: true,
                                multiple: true,
                                "hide-selected": true,
                                "close-on-select": false,
                                "clear-on-select": true,
                                "open-direction": "bottom",
                                label: "label",
                                "track-by": "value",
                                hideArrow: false,
                                placeholder: "search Global Teams"
                              }, {
                                noResult: _withCtx(() => [
                                  _hoisted_75
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "options", "class"]),
                              (_ctx.v$.locationBasedOptions.departments.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                    (_ctx.v$.locationBasedOptions.departments.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20302 && _ctx.locationBasedOptions.region)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                              _hoisted_79,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["inputboxstyling text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.entityId.$error
												}]),
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.locationBasedOptions.entityId) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.getEntityTeamsList(_ctx.locationBasedOptions.entityId)))
                              }, [
                                _hoisted_81,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityData1, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: option.id,
                                    value: option._id
                                  }, _toDisplayString(option.entityName), 9, _hoisted_82))
                                }), 128))
                              ], 42, _hoisted_80), [
                                [_vModelSelect, _ctx.locationBasedOptions.entityId]
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20302 && _ctx.locationBasedOptions.region && _ctx.locationBasedOptions.entityId)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _hoisted_84,
                              _withDirectives(_createElementVNode("select", {
                                class: _normalizeClass(["inputboxstyling text-black", {
													'is-invalid': _ctx.v$.locationBasedOptions.courseTargetTypeCodeId.$error
												}]),
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.locationBasedOptions.courseTargetTypeCodeId) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleAccessLevelTwoChange && _ctx.handleAccessLevelTwoChange(...args)))
                              }, [
                                _hoisted_86,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLevelTwo, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: option.id,
                                    value: option.courseTargetTypeCodeId,
                                    class: _normalizeClass({ hidden: option.id == 10503 })
                                  }, _toDisplayString(option.data), 11, _hoisted_87))
                                }), 128))
                              ], 42, _hoisted_85), [
                                [_vModelSelect, _ctx.locationBasedOptions.courseTargetTypeCodeId]
                              ]),
                              (_ctx.v$.locationBasedOptions.courseTargetTypeCodeId.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                    (_ctx.v$.locationBasedOptions.courseTargetTypeCodeId.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_89, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_90, [
                        (_ctx.locationBasedOptions.type == 20302 && _ctx.locationBasedOptions.courseTargetTypeCodeId == 10502)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, _hoisted_93))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20302 && _ctx.locationBasedOptions.courseTargetTypeCodeId == 10503)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, _hoisted_96))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20303 && _ctx.locationBasedOptions.courseTargetTypeCodeId == 10502)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                              _hoisted_98,
                              _createVNode(_component_multiselect, {
                                modelValue: _ctx.locationBasedOptions.departments,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.locationBasedOptions.departments) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                class: _normalizeClass(["custom-multiselect text-black", {
													'is-invalidmultiselect':_ctx.v$.locationBasedOptions.departments.$error,
													'has-options': _ctx.entitysTeams && _ctx.entitysTeams.length > 0,
                                    				'no-options': !_ctx.entitysTeams.length &&  _ctx.searchValue !== '',
												}]),
                                options: _ctx.entitysTeams,
                                searchable: true,
                                showNoOptions: false,
                                multiple: true,
                                "hide-selected": true,
                                "close-on-select": false,
                                "clear-on-select": true,
                                "open-direction": "bottom",
                                label: "label",
                                "track-by": "value",
                                hideArrow: false,
                                placeholder: "Search Location Teams"
                              }, {
                                noResult: _withCtx(() => [
                                  _hoisted_99
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "options", "class"]),
                              (_ctx.v$.locationBasedOptions.departments.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                    (_ctx.v$.locationBasedOptions.departments.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.locationBasedOptions.type == 20303 && _ctx.locationBasedOptions.courseTargetTypeCodeId == 10503)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              _hoisted_103,
                              _createVNode(_component_multiselect, {
                                modelValue: _ctx.locationBasedOptions.users,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.locationBasedOptions.users) = $event)),
                                disabled: _ctx.locationBasedOptionsDisable==false,
                                class: _normalizeClass(["custom-multiselect text-black", {
													'is-invalidmultiselect':_ctx.v$.locationBasedOptions.users.$error,
													'has-options': _ctx.entitysUsers && _ctx.entitysUsers.length > 0,
                                    				'no-options': !_ctx.entitysUsers.length &&  _ctx.searchValue !== '',
												}]),
                                options: _ctx.entitysUsers,
                                showNoOptions: false,
                                searchable: true,
                                multiple: true,
                                "hide-selected": true,
                                "close-on-select": false,
                                "clear-on-select": true,
                                "open-direction": "bottom",
                                label: "label",
                                "track-by": "value",
                                hideArrow: false,
                                placeholder: "Search Users"
                              }, {
                                noResult: _withCtx(() => [
                                  _hoisted_104
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "options", "class"]),
                              (_ctx.v$.locationBasedOptions.users.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                    (_ctx.v$.locationBasedOptions.users.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_107, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "forceUpdate",
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.locationBasedOptions.forceUpdate) = $event)),
                          class: "cursor-pointer checkbox",
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.enableLocationBasedOptions(_ctx.locationBasedOptions.forceUpdate)))
                        }, null, 544), [
                          [_vModelCheckbox, _ctx.locationBasedOptions.forceUpdate]
                        ]),
                        _hoisted_108
                      ]),
                      _createElementVNode("div", _hoisted_109, [
                        (_ctx.addPopupData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(_ctx.allEmptyValues ? 'btndisabled pointer-events-none' : 'btnprimary '),
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.cancelPermissions1()))
                              }, " Cancel ", 2)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_111, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(_ctx.compareObjects ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.cancelPermissions()))
                              }, " Cancel ", 2)
                            ])),
                        (_ctx.addPopupData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(_ctx.allEmptyValues ? 'btndisabled pointer-events-none' : 'btnprimary '),
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.savePermissions()))
                              }, " Save ", 2)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_113, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(_ctx.compareObjects ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.updatePermissions(_ctx.showIndex)))
                              }, " Update ", 2)
                            ]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}